(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.xpoint = {}));
}(this, (function (exports) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    // Unique ID creation requires a high quality random # generator. In the browser we therefore
    // require the crypto API and do not support built-in fallback to lower quality random number
    // generators (like Math.random()).
    var getRandomValues;
    var rnds8 = new Uint8Array(16);
    function rng() {
      // lazy load so that environments that need to polyfill have a chance to do so
      if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

        if (!getRandomValues) {
          throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        }
      }

      return getRandomValues(rnds8);
    }

    var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

    function validate(uuid) {
      return typeof uuid === 'string' && REGEX.test(uuid);
    }

    /**
     * Convert array of 16 byte values to UUID string format of the form:
     * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
     */

    var byteToHex = [];

    for (var i = 0; i < 256; ++i) {
      byteToHex.push((i + 0x100).toString(16).substr(1));
    }

    function stringify(arr) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      // Note: Be careful editing this code!  It's been tuned for performance
      // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
      var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
      // of the following:
      // - One or more input array values don't map to a hex octet (leading to
      // "undefined" in the uuid)
      // - Invalid input values for the RFC `version` or `variant` fields

      if (!validate(uuid)) {
        throw TypeError('Stringified UUID is invalid');
      }

      return uuid;
    }

    function v4(options, buf, offset) {
      options = options || {};
      var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

      rnds[6] = rnds[6] & 0x0f | 0x40;
      rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

      if (buf) {
        offset = offset || 0;

        for (var i = 0; i < 16; ++i) {
          buf[offset + i] = rnds[i];
        }

        return buf;
      }

      return stringify(rnds);
    }

    class CheckRequestStatus {
    }
    CheckRequestStatus.ALLOWED = "ALLOWED";
    CheckRequestStatus.DENIED = "DENIED";
    CheckRequestStatus.WAITING = "WAITING";
    CheckRequestStatus.IDLE = "IDLE";

    var RequestType;
    (function (RequestType) {
        RequestType["FORCE"] = "FORCE";
        RequestType["INTERVAL"] = "INTERVAL";
        RequestType["FORCE_CHANGE_IP"] = "FORCE_CHANGE_IP";
        RequestType["BORDER_PROXIMITY"] = "BORDER_PROXIMITY";
        RequestType["WAGERING_START"] = "WAGERING_START";
        RequestType["JURISDICTION_AREA"] = "JURISDICTION_AREA";
    })(RequestType || (RequestType = {}));

    class SdkMetric {
    }
    SdkMetric.GPS_COLLECTION_TIME = "GPS_COLLECTION_TIME";
    SdkMetric.TIME_TO_FIRST_CHECK = "TIME_TO_FIRST_CHECK";
    SdkMetric.NUM_OF_ATTEMPTS = "NUM_OF_ATTEMPTS";
    SdkMetric.INIT_REQUEST_RESPONSE_TIME = "INIT_REQUEST_RESPONSE_TIME";
    SdkMetric.GPS_SEND_TIME = "GPS_SEND_TIME";
    SdkMetric.DEVICEINFO_COLLECTION_TIME = "DEVICEINFO_COLLECTION_TIME";
    SdkMetric.WIFI_COLLECTION_TIME = "WIFI_COLLECTION_TIME";
    SdkMetric.APP_COLLECTION_TIME = "APP_COLLECTION_TIME";
    SdkMetric.CELL_COLLECTION_TIME = "CELL_COLLECTION_TIME";
    SdkMetric.OTHER_METRIC = "OTHER_METRIC";
    SdkMetric.DEVICEINFO_SEND_TIME = "DEVICEINFO_SEND_TIME";
    SdkMetric.WIFI_SEND_TIME = "WIFI_SEND_TIME";
    SdkMetric.CELL_SEND_TIME = "CELL_SEND_TIME";
    SdkMetric.APP_SEND_TIME = "APP_SEND_TIME";
    SdkMetric.AVERAGE_FORCE_RESULT_TIME = "AVERAGE_FORCE_RESULT_TIME";

    const buildLoginUrl = (baseUrl, options) => {
        return buildUrl('login', baseUrl, options).toString();
    };
    const buildUrlWithLoginOptions = (path, baseUrl, options) => {
        return buildUrl(path, baseUrl, options);
    };
    const buildWageringStartUrl = (baseUrl, options) => {
        return buildUrlWithLoginOptions('wagering-start', baseUrl, options);
    };
    const buildUrl = (path, baseUrl, options) => {
        const url = new URL(path, baseUrl);
        addQueryParamIfExist(url, 'userId', options === null || options === void 0 ? void 0 : options.userId);
        addQueryParamIfExist(url, 'client', options === null || options === void 0 ? void 0 : options.client);
        addQueryParamIfExist(url, 'customData', options === null || options === void 0 ? void 0 : options.customData);
        addQueryParamIfExist(url, 'clientBrand', options === null || options === void 0 ? void 0 : options.clientBrand);
        return url;
    };
    const wait = (seconds) => {
        return new Promise((resolve) => {
            setTimeout(resolve, seconds * 1000, {});
        });
    };
    const addQueryParamIfExist = (url, name, value) => {
        if (value) {
            // https://stackoverflow.com/questions/51954827/decode-plus-sign-to-space-in-urlcomponent
            // url.searchParams.append(name, value);
            url.search += !url.search ? '?' : '&';
            url.search += `${name}=${encodeURIComponent(value)}`;
        }
    };

    var version = "3.4.0";

    const requestTimeout = 10000; // 10 seconds
    class FetchRequest {
        constructor(url, options) {
            this.url = url;
            this.options = options || {};
        }
        send(headersInterceptor) {
            const rejectAfterTimeout = new Promise(
            // @ts-ignore
            (resolve, reject) => setTimeout(reject, requestTimeout, new Error('Timeout error')));
            return Promise.race([
                this._send(headersInterceptor),
                rejectAfterTimeout
            ]);
        }
        sendWithRetry(retryCount, retryTimeout, headersInterceptor) {
            return __awaiter(this, void 0, void 0, function* () {
                const rejectAfterTimeout = new Promise(
                // @ts-ignore
                (resolve, reject) => setTimeout(reject, requestTimeout, new Error('Timeout error')));
                return Promise.race([
                    this._sendWithRetry(retryCount, retryTimeout, headersInterceptor),
                    rejectAfterTimeout
                ]);
            });
        }
        _send(headersInterceptor) {
            return fetch(this.url, this.options).then((response) => {
                if (response.ok) {
                    return new Promise((resolve, reject) => {
                        response.json().then(data => {
                            if (headersInterceptor) {
                                const extra = headersInterceptor(response.headers);
                                resolve(Object.assign(Object.assign({}, data), extra));
                            }
                            else {
                                resolve(data);
                            }
                        }).catch(e => reject(e));
                    });
                }
                return response.json().then((data) => {
                    return Promise.reject({
                        status: response.status,
                        statusText: response.statusText,
                        message: (data === null || data === void 0 ? void 0 : data.message) || (data === null || data === void 0 ? void 0 : data.info)
                    });
                });
            });
        }
        _sendWithRetry(retryCount, retryTimeout, headersInterceptor) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    return yield this.send(headersInterceptor);
                }
                catch (e) {
                    if (retryCount > 0) {
                        yield wait(retryTimeout);
                        return this.sendWithRetry(retryCount - 1, retryTimeout, headersInterceptor);
                    }
                    else {
                        throw e;
                    }
                }
            });
        }
    }

    // A Core Data timestamp is the number of seconds (or nanoseconds) since midnight, January 1, 2001, GMT
    // The difference between a Core Data timestamp and a Unix timestamp (seconds since 1/1/1970) is 978307200 seconds.
    const MAC_AND_UNIX_CORE_TIME_DIFF = 978307200000; // millis
    const NO_USER = 'no_user';
    const sendRequest = (path, body, apiKey, headersInterceptor) => {
        const headers = {
            'x-api-key': apiKey,
            'content-type': 'application/json'
        };
        return new FetchRequest(path, {
            method: 'POST',
            body,
            headers
        }).sendWithRetry(1, 1, headersInterceptor);
    };
    const generateApiKey = (clientKey) => __awaiter(void 0, void 0, void 0, function* () {
        const message = `O50rhDrqW6POa1jIDAKK^${clientKey.length}${clientKey.toLowerCase()}`;
        const msgUint8 = new TextEncoder().encode(message);
        const hashBuffer = yield crypto.subtle.digest('SHA-1', msgUint8);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
    });
    const coordToE6 = (latitude) => {
        return Math.round(latitude * 1e6);
    };
    const getCurrentPosition = (options) => __awaiter(void 0, void 0, void 0, function* () {
        const rejectAfterTimeout = new Promise(
        // @ts-ignore
        (resolve, reject) => setTimeout(reject, options.timeout, new Error(`Unable to get current geo position within timeout ${options.timeout}`)));
        return Promise.race([
            _tryToGetCurrentPosition(options),
            rejectAfterTimeout
        ]);
    });
    const _tryToGetCurrentPosition = (options) => __awaiter(void 0, void 0, void 0, function* () {
        if (navigator.geolocation) {
            const position = yield new Promise((resolve, reject) => navigator.geolocation.getCurrentPosition(resolve, reject, options));
            const timestamp = convertCocoaTimestampToUnixIfNeeded(position.timestamp);
            return Promise.resolve({
                coords: position.coords,
                timestamp
            });
        }
        else {
            return new Promise(resolve => resolve(null));
        }
    });
    const getApiUrl = (host) => {
        const apiHost = host !== null && host !== void 0 ? host : localStorage.getItem('xpjs.apiHost');
        if (apiHost && /xp23.xpoint.tech$/i.test(apiHost)) {
            return `https://${apiHost}`;
        }
        return "https://xp23.xpoint.tech";
    };
    const patchSession = (sessionData) => {
        const session = Object.assign(Object.assign({}, loadSession()), sessionData);
        saveSession(session);
    };
    const loadSession = () => {
        return loadFromStorage('xpjs.session');
    };
    const saveSession = (session) => {
        saveToStorage(session, 'xpjs.session');
    };
    const loadFromStorage = (key) => {
        return JSON.parse(localStorage.getItem(key) || '{}');
    };
    const saveToStorage = (data, key) => {
        localStorage.setItem(key, JSON.stringify(data));
    };
    const getDeviceInfo = () => {
        return {
            brand: "UNKNOWN",
            model: "UNKNOWN",
            osVersion: "UNKNOWN"
        };
    };
    const positionToGpsItems = (userKey, pos) => {
        var _a, _b, _c;
        const gpsItems = pos ? [
            {
                accuracy: pos.coords.accuracy,
                altitude: (_a = pos.coords.altitude) !== null && _a !== void 0 ? _a : undefined,
                altitudeAccuracy: (_b = pos.coords.altitudeAccuracy) !== null && _b !== void 0 ? _b : undefined,
                speed: (_c = pos.coords.speed) !== null && _c !== void 0 ? _c : undefined,
                timestamp: pos.timestamp,
                latitudeE6: coordToE6(pos.coords.latitude),
                longitudeE6: coordToE6(pos.coords.longitude),
                adId: 'unknown',
                provider: 'xpoint-lite',
            }
        ] : [];
        return {
            systemInfo: {
                platform: 'UNKNOWN',
                jsVersion: version,
            },
            idType: 'UNKNOWN',
            rows: gpsItems,
            userKey
        };
    };
    const getClientInfo = (userId, deviceId, requestType, checkPhase, customData, clientBrand) => {
        return Object.assign(Object.assign(Object.assign({ userId,
            deviceId, systemInfo: {
                platform: 'UNKNOWN',
                jsVersion: version
            }, deviceInfo: getDeviceInfo() }, (customData ? { customData } : null)), (clientBrand ? { clientBrand } : null)), { requestType,
            checkPhase });
    };
    const isCocoaTimestamp = (timestamp) => {
        return timestamp < (Date.now() - MAC_AND_UNIX_CORE_TIME_DIFF);
    };
    const convertCocoaTimestampToUnix = (cocoaTimestamp) => {
        return cocoaTimestamp + MAC_AND_UNIX_CORE_TIME_DIFF;
    };
    const convertCocoaTimestampToUnixIfNeeded = (timestamp) => {
        return isCocoaTimestamp(timestamp) ? convertCocoaTimestampToUnix(timestamp) : timestamp;
    };

    class ServerTimeEstimator {
        constructor() {
            this.timeDiffInMillis = 0;
            this.lastTimeSnapshot = Date.now();
        }
        convertTimeToServer(clientTime) {
            return clientTime - this.timeDiffInMillis;
        }
        estimateDifference(serverTime, beforePing) {
            this.timeDiffInMillis = serverTime != null ? beforePing - serverTime : 0;
        }
        resetTimeModification() {
            this.lastTimeSnapshot = Date.now();
        }
        checkIsTimeModified() {
            return this.lastTimeSnapshot > Date.now();
        }
    }

    var JobStatus;
    (function (JobStatus) {
        JobStatus["SCHEDULED"] = "SCHEDULED";
        JobStatus["IN_PROGRESS"] = "IN_PROGRESS";
        JobStatus["FAILED"] = "FAILED";
        JobStatus["COMPLETED"] = "COMPLETED";
    })(JobStatus || (JobStatus = {}));
    var CheckPhase;
    (function (CheckPhase) {
        CheckPhase["INITIAL"] = "INITIAL";
        CheckPhase["RECHECK"] = "RECHECK";
    })(CheckPhase || (CheckPhase = {}));
    var PingApiCode;
    (function (PingApiCode) {
        PingApiCode["FORCE"] = "FORCE";
        PingApiCode["FORCE_CHANGE_IP"] = "FORCE_CHANGE_IP";
        PingApiCode["INTERVAL"] = "INTERVAL";
    })(PingApiCode || (PingApiCode = {}));

    class WebSdkLiteImpl {
        constructor() {
        }
        gps(apiKey, apiUrl, data) {
            return __awaiter(this, void 0, void 0, function* () {
                return sendRequest(`${apiUrl}/gps`, JSON.stringify(data), apiKey);
            });
        }
        forceResult(apiKey, apiUrl, data, headersInterceptor) {
            return __awaiter(this, void 0, void 0, function* () {
                return sendRequest(`${apiUrl}/force-result`, JSON.stringify(data), apiKey, headersInterceptor);
            });
        }
        initForce(apiKey, apiUrl, data) {
            return sendRequest(`${apiUrl}/init-force`, JSON.stringify(data), String(apiKey));
        }
        checkStatus(apiKey, apiUrl, data, headersInterceptor) {
            return sendRequest(`${apiUrl}/check-status`, JSON.stringify(data), String(apiKey), headersInterceptor);
        }
        pingApi(apiKey, apiUrl, data) {
            return sendRequest(`${apiUrl}/pingapi`, JSON.stringify(data), String(apiKey));
        }
        sendMetrics(apiKey, apiUrl, request) {
            return sendRequest(`${apiUrl}/sdk-metrics`, JSON.stringify(request), String(apiKey));
        }
        addMissingRequest(apiKey, apiUrl, data) {
            return sendRequest(`${apiUrl}/missing-requests`, JSON.stringify(data), String(apiKey));
        }
        getJurisdictionArea(apiKey, apiUrl, request) {
            return __awaiter(this, void 0, void 0, function* () {
                return sendRequest(`${apiUrl}/jurisdiction-area`, JSON.stringify(request), String(apiKey));
            });
        }
        getJurisdictionAreaDictionary(apiKey, apiUrl, clientBrand) {
            return __awaiter(this, void 0, void 0, function* () {
                return sendRequest(`${apiUrl}/jurisdiction-area-dictionary`, JSON.stringify(Object.assign({}, (clientBrand ? { clientBrand } : null))), String(apiKey));
            });
        }
        getGameTypes(apiKey, apiUrl, jurisdictionArea, clientBrand) {
            return __awaiter(this, void 0, void 0, function* () {
                const request = Object.assign({ jurisdictionArea: jurisdictionArea }, (clientBrand ? { clientBrand } : null));
                return sendRequest(`${apiUrl}/game-types`, JSON.stringify(request), String(apiKey));
            });
        }
    }

    class Cache {
        constructor(ttl) {
            this._cache = {};
            this.ttl = ttl;
        }
        get(key) {
            const entry = this._cache[key];
            if (entry && entry.expiresAt > Date.now()) {
                return entry.value;
            }
            return undefined;
        }
        set(key, value) {
            this._cache[key] = { value: value, expiresAt: Date.now() + this.ttl };
        }
    }

    const defaultConfigUrl = "https://routing.xpoint.tech";
    const validBaseRegex = /^[a-z0-9-]*$/;
    const CACHE_TTL = 15 * 60 * 1000; // 15 mins
    class RoutingService {
        constructor(options) {
            this.apiUrlByClientKey = new Cache(CACHE_TTL);
            this.options = options;
        }
        static isValidBase(base) {
            return validBaseRegex.test(base);
        }
        fetchApiUrl(clientKey) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const cached = this.apiUrlByClientKey.get(clientKey);
                if (cached) {
                    return Promise.resolve(cached);
                }
                const defaultUrl = getApiUrl((_a = this.options) === null || _a === void 0 ? void 0 : _a.apiHost);
                try {
                    const configUrl = ((_b = this.options) === null || _b === void 0 ? void 0 : _b.configUrl) ? this.options.configUrl : defaultConfigUrl;
                    const conf = yield this._fetchConfig(configUrl, clientKey);
                    const base = (_c = conf === null || conf === void 0 ? void 0 : conf.application) === null || _c === void 0 ? void 0 : _c['base-entry'];
                    if (base) {
                        if (RoutingService.isValidBase(base)) {
                            const apiUrl = `https://${base}.xpoint.tech`;
                            this.apiUrlByClientKey.set(clientKey, apiUrl);
                            console.log(`Config: ${apiUrl}`);
                            return Promise.resolve(apiUrl);
                        }
                        else {
                            console.log(`Invalid base in config: ${base}`);
                        }
                    }
                }
                catch (e) {
                    // do nothing, use default config
                }
                this.apiUrlByClientKey.set(clientKey, defaultUrl);
                return Promise.resolve(defaultUrl);
            });
        }
        _fetchConfig(configUrl, clientKey) {
            const requestUrl = `${configUrl}/api/v1/clients/${clientKey}`;
            return fetch(requestUrl, {
                headers: {
                    accept: 'application/json, text/plain, */*',
                },
            }).then(response => {
                if (response.ok) {
                    return response.json();
                }
                console.log('Failed to fetch config, use default.');
                return Promise.reject();
            });
        }
    }

    const XPOINT_JWT_HEADER_NAME$1 = 'xpoint-jwt';
    const MAX_LOCAL_ERRORS = 2;
    const NO_INTERNET_CONNECTION_ERROR = {
        code: 0,
        description: "We cannot verify that you're within a permitted area. To help us verify your location make sure your"
            + " Location Services is turned on and that multiple WiFi connections are within range of your device. Please, address items above then try again."
    };
    const SERVICE_OVERLOADED_ERROR = {
        code: 0,
        description: "The service is temporarily overloaded. Please try again later."
    };
    const TIME_MANIPULATION_ERROR = {
        code: 3006,
        description: "We have detected that the device time has been modified. Please correct the time on your device to match your time zone, then try again."
    };
    const positionMaximumAge = 20 * 1000; // 20 seconds, cache time to live
    const positionRetrieveTimeout = 60000; // 1 min - time to wait for retrieving position data from the device
    const quickPositionRetrieveTimeout = 5 * 1000; // 5 seconds - time to wait for retrieving position data from the device
    const forceUpdatePositionTime = 15; // each 15 seconds update location data manually
    const positionEnableHighAccuracy = false;
    class WebSdkLiteClientImpl {
        constructor(options) {
            this.session = {};
            this.watchPositionHandlerId = null;
            this.apiTokenMap = {};
            this.routingService = new RoutingService(options);
            this.webSdkLite = new WebSdkLiteImpl();
            this.serverTimeEstimator = new ServerTimeEstimator();
            this.init();
        }
        static headersInterceptor(headers) {
            const jwt = headers.get(XPOINT_JWT_HEADER_NAME$1);
            return Object.assign({}, (jwt ? { jwt } : null));
        }
        /**
         * Start new session from scratch.
         * Generate RequestID -  used across requests
         * Generate unique ID - replacement for deviceID which is not available in browser. This ID is stored in
         * localStorage (persistent between user sessions).
         */
        init() {
            // Ensure deviceId
            this.session.deviceId = loadSession().deviceId;
            if (!this.session.deviceId) {
                this.session.deviceId = v4();
                patchSession({ deviceId: this.session.deviceId });
            }
            // Start sending data to the backend in background
            this.startSendingPingApi();
        }
        /**
         * Set userId and client, generate apiKey based for given client
         */
        setUserId(userId, client, customData, clientBrand) {
            return __awaiter(this, void 0, void 0, function* () {
                const apiKey = yield generateApiKey(client);
                this.session = Object.assign(Object.assign(Object.assign(Object.assign({ deviceId: this.session.deviceId, apiKey }, (userId ? { userId } : null)), (client ? { client } : null)), (customData ? { customData } : null)), (clientBrand ? { clientBrand } : null));
                this.startWatchingPositionOnce();
                return userId;
            });
        }
        liteCheck(jurisdictionArea) {
            return __awaiter(this, void 0, void 0, function* () {
                const startFullTime = Date.now();
                if (!this.session.userId || !this.session.client) {
                    return Promise.reject("Set userId before starting game.");
                }
                const clientKey = this.session.client;
                const apiUrl = yield this.routingService.fetchApiUrl(clientKey);
                const apiKey = yield this.generateApiTokenIfNeeded(clientKey);
                this.serverTimeEstimator.resetTimeModification();
                const position = yield this.getMostRecentPosition();
                const endGpsCollectingTime = Date.now();
                const userId = this.session.userId || "";
                const deviceId = this.session.deviceId || "";
                const clientBrand = this.session.clientBrand;
                const userKey = Object.assign(Object.assign({ userId,
                    deviceId }, (clientBrand ? { clientBrand } : null)), (jurisdictionArea ? { jurisdictionArea } : null));
                const gpsItems = positionToGpsItems(userKey, position);
                // send request asynchronously, no need to wait for response
                this.webSdkLite.gps(apiKey, apiUrl, gpsItems).catch(e => console.log(e));
                this.sendPingApi(apiKey, apiUrl, jurisdictionArea);
                const requestId = v4();
                let initForceResp;
                let forceResultResp;
                let endInitRequestResponseTime;
                let numOfAttempts = 1;
                try {
                    initForceResp = yield this.webSdkLite.initForce(apiKey, apiUrl, {
                        clientInfo: Object.assign(Object.assign(Object.assign({}, this.getCurrentClientInfo()), { requestId, initialRequestId: requestId, requestType: RequestType.FORCE }), (jurisdictionArea ? { jurisdictionArea } : null))
                    });
                    endInitRequestResponseTime = Date.now();
                    let timeout = 1; // pause between /init-force response and /force-request request = 1 sec.
                    const retryLimit = 2 * 60 * 1000; // retry /force-result for 2 minutes (120 secs / timeout between queries);
                    const increaseTimeoutAfter = 5 * 1000; // increase retry timeout after first 5 seconds
                    const startTime = this.now();
                    while ((forceResultResp === null || forceResultResp === void 0 ? void 0 : forceResultResp.jobStatus) !== JobStatus.COMPLETED
                        && (forceResultResp === null || forceResultResp === void 0 ? void 0 : forceResultResp.jobStatus) !== JobStatus.FAILED
                        && (this.now() - startTime) < retryLimit) {
                        yield wait(timeout);
                        if ((this.now() - startTime) > increaseTimeoutAfter) {
                            timeout += 1;
                        }
                        const requestId = v4();
                        forceResultResp = yield this.webSdkLite.forceResult(apiKey, apiUrl, {
                            jobId: initForceResp.jobId,
                            clientInfo: Object.assign(Object.assign(Object.assign({}, this.getCurrentClientInfo()), { requestId, initialRequestId: requestId, requestType: RequestType.FORCE }), (jurisdictionArea ? { jurisdictionArea } : null))
                        }, WebSdkLiteClientImpl.headersInterceptor);
                        numOfAttempts = numOfAttempts + 1;
                    }
                }
                catch (e) {
                    // Network error. Stop game with location not available status;
                    const checkRequestResult = {
                        status: CheckRequestStatus.DENIED,
                        errors: [NO_INTERNET_CONNECTION_ERROR]
                    };
                    this.checkRequestUpdated(checkRequestResult);
                    this.registerLocalError(NO_INTERNET_CONNECTION_ERROR);
                    return checkRequestResult;
                }
                if (forceResultResp && forceResultResp.jobStatus === JobStatus.COMPLETED) {
                    const endFullTime = Date.now();
                    this.sendSdkMetrics(apiKey, apiUrl, Object.assign({ fullTime: endFullTime - startFullTime, gpsCollectingTime: endGpsCollectingTime - startFullTime, checkRequestId: requestId, numOfAttempts: numOfAttempts }, (endInitRequestResponseTime ? { initRequestResponseTime: endInitRequestResponseTime - startFullTime } : null)));
                    const checkRequestData = Object.assign(Object.assign({}, forceResultResp.data), ((forceResultResp === null || forceResultResp === void 0 ? void 0 : forceResultResp.jwt) ? { jwt: forceResultResp === null || forceResultResp === void 0 ? void 0 : forceResultResp.jwt } : null));
                    this.checkRequestUpdated(checkRequestData);
                    return checkRequestData;
                }
                else {
                    const checkRequestResult = {
                        status: CheckRequestStatus.DENIED,
                        errors: [SERVICE_OVERLOADED_ERROR]
                    };
                    this.checkRequestUpdated(checkRequestResult);
                    this.registerLocalError(SERVICE_OVERLOADED_ERROR);
                    return checkRequestResult;
                }
            });
        }
        sendSdkMetrics(apiKey, apiUrl, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const sdkMetricsRequest = {
                    clientInfo: Object.assign(Object.assign({}, this.getCurrentClientInfo()), { requestId: options.checkRequestId }),
                    userId: String(this.session.userId),
                    deviceId: String(this.session.deviceId),
                    checkRequestId: options.checkRequestId,
                    metrics: [
                        {
                            metric: SdkMetric.TIME_TO_FIRST_CHECK,
                            value: options.fullTime
                        },
                        {
                            metric: SdkMetric.GPS_COLLECTION_TIME,
                            value: options.gpsCollectingTime
                        },
                        {
                            metric: SdkMetric.NUM_OF_ATTEMPTS,
                            value: options.numOfAttempts
                        },
                        ...(options.initRequestResponseTime ? [{
                                metric: SdkMetric.INIT_REQUEST_RESPONSE_TIME,
                                value: options.initRequestResponseTime
                            }] : [])
                    ]
                };
                try {
                    this.webSdkLite.sendMetrics(apiKey, apiUrl, sdkMetricsRequest);
                }
                catch (e) {
                    // do nothing
                }
            });
        }
        /**
         * Send /pingapi data to the backend each 1 minute
         */
        startSendingPingApi() {
            return __awaiter(this, void 0, void 0, function* () {
                while (true) {
                    yield wait(60); // 1 minute
                    try {
                        if (this.session.userId && this.session.client) {
                            const clientKey = this.session.client;
                            const apiUrl = yield this.routingService.fetchApiUrl(clientKey);
                            const apiKey = yield this.generateApiTokenIfNeeded(clientKey);
                            yield this.sendPingApi(apiKey, apiUrl);
                        }
                    }
                    catch (e) {
                        // internet communication error
                        // game will be stopped in next interval check if failed
                    }
                }
            });
        }
        startWatchingPositionOnce() {
            return __awaiter(this, void 0, void 0, function* () {
                // Check if browser supports geolocation and if not already started watching position
                if (this.watchPositionHandlerId || !navigator.geolocation) {
                    return;
                }
                // Watch position change and store to this.currentPosition. Send to the backend the most relevant data when needed.
                const options = {
                    enableHighAccuracy: positionEnableHighAccuracy,
                    maximumAge: positionMaximumAge,
                    timeout: positionRetrieveTimeout
                };
                this.watchPositionHandlerId = navigator.geolocation.watchPosition(position => this.positionUpdated(position), () => {
                }, options);
                // In case if watchPosition stopped watching (e.g. location service was disabled and re-enabled) we update
                // position additionally
                while (true) {
                    if (!this.isCurrentPositionValid()) {
                        const options = {
                            enableHighAccuracy: positionEnableHighAccuracy,
                            maximumAge: positionMaximumAge,
                            timeout: positionRetrieveTimeout
                        };
                        const position = yield getCurrentPosition(options).catch((err) => {
                            console.warn(`ERROR: ${err.message}`);
                        });
                        if (position) {
                            this.positionUpdated(position);
                        }
                    }
                    yield wait(forceUpdatePositionTime); // wait 15 secs
                }
            });
        }
        isCurrentPositionValid() {
            var _a;
            return !!(((_a = this.currentPosition) === null || _a === void 0 ? void 0 : _a.timestamp) && (this.currentPosition.timestamp > (this.now() - positionMaximumAge)));
        }
        positionUpdated(position) {
            const timestamp = convertCocoaTimestampToUnixIfNeeded(position.timestamp);
            this.currentPosition = {
                coords: position.coords,
                timestamp
            };
        }
        getMostRecentPosition() {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.isCurrentPositionValid()) {
                    return Promise.resolve(this.currentPosition);
                }
                const options = {
                    enableHighAccuracy: positionEnableHighAccuracy,
                    maximumAge: positionMaximumAge,
                    timeout: quickPositionRetrieveTimeout
                };
                const position = yield getCurrentPosition(options).catch((err) => {
                    console.warn(`ERROR: ${err.message}`);
                });
                if (position) {
                    this.positionUpdated(position);
                }
                // if unable to quickly get location send last received location data
                return this.currentPosition;
            });
        }
        now() {
            return this.serverTimeEstimator.convertTimeToServer(Date.now());
        }
        getJurisdictionArea(clientKey, clientBrand) {
            return __awaiter(this, void 0, void 0, function* () {
                const apiKey = yield this.generateApiTokenIfNeeded(clientKey);
                const apiUrl = yield this.routingService.fetchApiUrl(clientKey);
                const position = yield this.getMostRecentPosition();
                const deviceId = this.session.deviceId || "";
                const userKey = Object.assign({ userId: NO_USER, deviceId }, (clientBrand ? { clientBrand } : null));
                const gpsItems = positionToGpsItems(userKey, position);
                const request = {
                    clientInfo: Object.assign(Object.assign({}, getClientInfo(NO_USER, String(this.session.deviceId), RequestType.JURISDICTION_AREA, CheckPhase.INITIAL, '', clientBrand)), { requestId: v4() }),
                    gpsItems: gpsItems.rows
                };
                return this.webSdkLite.getJurisdictionArea(apiKey, apiUrl, request);
            });
        }
        getJurisdictionAreaDictionary(clientKey, clientBrand) {
            return __awaiter(this, void 0, void 0, function* () {
                const apiKey = yield this.generateApiTokenIfNeeded(clientKey);
                const apiUrl = yield this.routingService.fetchApiUrl(clientKey);
                return this.webSdkLite.getJurisdictionAreaDictionary(apiKey, apiUrl, clientBrand);
            });
        }
        getGameTypes(jurisdictionArea, clientKey, clientBrand) {
            return __awaiter(this, void 0, void 0, function* () {
                const apiKey = yield this.generateApiTokenIfNeeded(clientKey);
                const apiUrl = yield this.routingService.fetchApiUrl(clientKey);
                return this.webSdkLite.getGameTypes(apiKey, apiUrl, jurisdictionArea, clientBrand);
            });
        }
        sendPingApi(apiKey, apiUrl, jurisdictionArea) {
            return __awaiter(this, void 0, void 0, function* () {
                // Stop game in case if time changed to the past
                if (this.serverTimeEstimator.checkIsTimeModified()) {
                    this.checkRequestUpdated({
                        status: CheckRequestStatus.DENIED,
                        errors: [TIME_MANIPULATION_ERROR]
                    });
                }
                const beforePing = Date.now();
                const pingApiResponse = yield this.webSdkLite.pingApi(apiKey, apiUrl, {
                    clientInfo: Object.assign(Object.assign(Object.assign({}, this.getCurrentClientInfo()), { requestId: v4() }), (jurisdictionArea ? { jurisdictionArea } : null))
                });
                this.serverTimeEstimator.estimateDifference(pingApiResponse.serverTime, beforePing);
                yield this.sendLocalErrors();
                return pingApiResponse;
            });
        }
        getCurrentClientInfo(checkPhase = CheckPhase.INITIAL) {
            return getClientInfo(String(this.session.userId), String(this.session.deviceId), RequestType.FORCE, checkPhase, this.session.customData, this.session.clientBrand);
        }
        checkRequestUpdated(checkStatus) {
            window.dispatchEvent(new CustomEvent("xpoint-sdk-message", { detail: checkStatus }));
        }
        registerLocalError(error) {
            if (!this.session.localErrors) {
                this.session.localErrors = [];
            }
            if (!this.session.localErrors.some(nextError => nextError.code === error.code)) {
                this.session.localErrors.push(Object.assign(Object.assign({}, error), { clientTimestamp: Date.now() }));
            }
        }
        sendLocalErrors() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (this.session.localErrors && this.session.localErrors.length > 0) {
                        const clientKey = this.session.client;
                        if (clientKey) {
                            const apiUrl = yield this.routingService.fetchApiUrl(clientKey);
                            const apiKey = yield this.generateApiTokenIfNeeded(clientKey);
                            const limit = Math.min(this.session.localErrors.length, MAX_LOCAL_ERRORS);
                            for (let i = 0; i < limit; i++) {
                                const nextError = this.session.localErrors[i];
                                yield this.webSdkLite.addMissingRequest(apiKey, apiUrl, {
                                    clientInfo: Object.assign(Object.assign({}, this.getCurrentClientInfo()), { requestId: v4() }),
                                    errorCode: 4000,
                                    failureReason: nextError.description,
                                    clientTimestamp: nextError.clientTimestamp || Date.now()
                                });
                            }
                        }
                        this.session.localErrors = [];
                    }
                }
                catch (e) {
                    // do nothing
                }
            });
        }
        generateApiTokenIfNeeded(clientKey) {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.apiTokenMap[clientKey]) {
                    return Promise.resolve(this.apiTokenMap[clientKey]);
                }
                this.apiTokenMap[clientKey] = yield generateApiKey(clientKey);
                return Promise.resolve(this.apiTokenMap[clientKey]);
            });
        }
    }

    class WebSdkDaemon {
        constructor(webSdk, headersInterceptor) {
            this.webSdk = webSdk;
            this.headersInterceptor = headersInterceptor;
            this._init();
        }
        static _checkRequestUpdated(status) {
            window.dispatchEvent(new CustomEvent("xpoint-sdk-message", { detail: status }));
        }
        startPolling(inverval, sessionId) {
            this.sessionId = sessionId;
            window.clearInterval(this.pollingTimerTask);
            const checkStatus = this._checkStatus.bind(this);
            this.pollingTimerTask = window.setInterval(checkStatus, inverval);
        }
        stopPolling() {
            window.clearInterval(this.pollingTimerTask);
        }
        _checkStatus() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!document.hidden) {
                    this.webSdk
                        .checkStatus(this.sessionId, this.headersInterceptor)
                        .then(status => {
                        WebSdkDaemon._checkRequestUpdated(status);
                    })
                        .catch(() => {
                        // network communication error, server errors, or 401 or 404 errors
                        WebSdkDaemon._checkRequestUpdated({ status: CheckRequestStatus.IDLE });
                    });
                }
            });
        }
        _init() {
            this._initListeners();
            this._startSendingLocationData();
        }
        _initListeners() {
            const stopPolling = this.stopPolling.bind(this);
            const startPolling = this.startPolling.bind(this);
            window.addEventListener("xpoint-sdk-message", event => {
                const checkRequest = event.detail;
                if (!checkRequest.status || checkRequest.status === CheckRequestStatus.DENIED
                    || checkRequest.status === CheckRequestStatus.IDLE) {
                    // stop polling if gambling is not allowed, polling will be
                    // restarted on the next wageringStart();
                    stopPolling();
                }
                else if (checkRequest.status === "ALLOWED") {
                    // change polling interval to 10 seconds when gambling is allowed
                    startPolling(10000, this.sessionId);
                }
            });
        }
        _sendLocationData(webSdk) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!document.hidden && this.sessionId) {
                    const options = {
                        enableHighAccuracy: true,
                        timeout: 5000,
                        maximumAge: 0
                    };
                    const pos = yield getCurrentPosition(options).catch((err) => {
                        console.warn(`ERROR: ${err.message}`);
                    });
                    if (pos) {
                        webSdk.sendEvent({
                            location: {
                                lat: pos.coords.latitude,
                                lon: pos.coords.longitude,
                                accuracy: pos.coords.accuracy
                            },
                            timestamp: pos.timestamp
                        }, this.sessionId).catch(() => {
                            // do nothing, ignore sending event failure, error may be in case if Xpoint Verify application terminated
                        });
                    }
                }
            });
        }
        _startSendingLocationData() {
            const sendLocationData = this._sendLocationData.bind(this);
            sendLocationData(this.webSdk);
            setInterval(sendLocationData, 30000, this.webSdk);
        }
    }

    const priorityOrigin = 'http://127.0.0.1';
    const fallbackOrigin = 'https://local.xpoint.tech';
    const httpPorts = [
        18354,
        18355,
        18356
    ];
    const httpsPorts = [
        28354,
        28355,
        28356
    ];
    const tryUrls = [
        ...httpPorts.map(p => `${priorityOrigin}:${p}`),
        ...httpsPorts.map(p => `${fallbackOrigin}:${p}`)
    ];
    const JA_ID_PARAM_NAME = 'jaId';
    const JA_NAME_PARAM_NAME = 'jaName';
    class WebSdkImpl {
        constructor() {
            this.baseURL = "";
            this.version = version;
        }
        static findLocalServiceUrl() {
            return __awaiter(this, void 0, void 0, function* () {
                let foundUrl;
                for (let i = 0; i < tryUrls.length; i++) {
                    try {
                        yield new FetchRequest(tryUrls[i] + "/status").send();
                        foundUrl = tryUrls[i];
                        break;
                    }
                    catch (e) {
                        // API is not available on this URL, try next one
                    }
                }
                if (!foundUrl) {
                    throw new Error("Local service is not launched");
                }
                return foundUrl;
            });
        }
        ensureApiIsAvailable() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.baseURL) {
                    this.baseURL = yield WebSdkImpl.findLocalServiceUrl();
                }
                return this.baseURL;
            });
        }
        health(options, sessionId) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.ensureApiIsAvailable();
                const url = buildUrlWithLoginOptions('status', this.baseURL, options);
                if (sessionId) {
                    url.searchParams.append('sessionId', sessionId);
                }
                return new FetchRequest(url.toString()).send();
            });
        }
        login(options) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.ensureApiIsAvailable();
                const loginUrl = buildLoginUrl(this.baseURL, options);
                return new FetchRequest(loginUrl).send();
            });
        }
        wageringStart(options, headersInterceptor, jurisdictionArea) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.ensureApiIsAvailable();
                const url = buildWageringStartUrl(this.baseURL, options);
                url.searchParams.append('v', this.version);
                if (jurisdictionArea) {
                    addQueryParamIfExist(url, JA_ID_PARAM_NAME, jurisdictionArea.id);
                    addQueryParamIfExist(url, JA_NAME_PARAM_NAME, jurisdictionArea.name);
                }
                return new FetchRequest(url.toString()).send(headersInterceptor);
            });
        }
        checkStatus(sessionId, headersInterceptor) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.ensureApiIsAvailable();
                const url = new URL(`${this.baseURL}/check-status`);
                if (sessionId) {
                    url.searchParams.append('sessionId', sessionId);
                }
                return new FetchRequest(url.toString()).send(headersInterceptor);
            });
        }
        wageringEnd(sessionId) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.ensureApiIsAvailable();
                const url = new URL(`${this.baseURL}/wagering-end`);
                if (sessionId) {
                    url.searchParams.append('sessionId', sessionId);
                }
                return new FetchRequest(url.toString()).send();
            });
        }
        sendEvent(event, sessionId) {
            return __awaiter(this, void 0, void 0, function* () {
                // send event only if Xpoint Verify launched
                if (this.baseURL) {
                    const url = new URL(`${this.baseURL}/send-event`);
                    Object.entries(event).forEach(([key, value]) => url.searchParams.append(key, JSON.stringify(value)));
                    if (sessionId) {
                        url.searchParams.append('sessionId', sessionId);
                    }
                    return new FetchRequest(url.toString()).send();
                }
                return Promise.resolve();
            });
        }
        getJurisdictionArea(client, clientBrand) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.ensureApiIsAvailable();
                const url = new URL(`${this.baseURL}/jurisdiction-area`);
                addQueryParamIfExist(url, 'client', client);
                addQueryParamIfExist(url, 'clientBrand', clientBrand);
                return new FetchRequest(url.toString()).send();
            });
        }
        getJurisdictionAreaDictionary(client, clientBrand) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.ensureApiIsAvailable();
                const url = new URL(`${this.baseURL}/jurisdiction-area-dictionary`);
                addQueryParamIfExist(url, 'client', client);
                addQueryParamIfExist(url, 'clientBrand', clientBrand);
                return new FetchRequest(url.toString()).send();
            });
        }
        getGameTypes(jurisdictionArea, client, clientBrand) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.ensureApiIsAvailable();
                const url = new URL(`${this.baseURL}/game-types`);
                addQueryParamIfExist(url, 'client', client);
                addQueryParamIfExist(url, JA_ID_PARAM_NAME, jurisdictionArea.id);
                addQueryParamIfExist(url, JA_NAME_PARAM_NAME, jurisdictionArea.name);
                addQueryParamIfExist(url, 'clientBrand', clientBrand);
                return new FetchRequest(url.toString()).send();
            });
        }
    }

    const XPOINT_JWT_HEADER_NAME = 'xpoint-jwt';
    const XPOINT_SESSION_ID_HEADER_NAME = 'xpoint-session-id';
    class WebSdkClientImpl {
        constructor() {
            this.webSdk = new WebSdkImpl();
            this.webSdkDaemon = new WebSdkDaemon(this.webSdk, WebSdkClientImpl.headersInterceptor);
        }
        static headersInterceptor(headers) {
            const jwt = headers.get(XPOINT_JWT_HEADER_NAME);
            const sessionId = headers.get(XPOINT_SESSION_ID_HEADER_NAME);
            return Object.assign(Object.assign({}, (jwt ? { jwt } : null)), (sessionId ? { sessionId } : null));
        }
        setUserId(userId, client, customData, clientBrand, sessionId) {
            return __awaiter(this, void 0, void 0, function* () {
                this.session = { sessionId };
                this.loginOptions = Object.assign(Object.assign(Object.assign({ userId }, (client ? { client } : null)), (customData ? { customData } : null)), (clientBrand ? { clientBrand } : null));
                this.webSdkDaemon.stopPolling(); // stop polling to prevent notifications from old session
                return userId;
            });
        }
        loginIfNeeded(options) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                if (!options || !options.userId) {
                    return Promise.reject("userId is required");
                }
                const health = yield this.webSdk.health(options, (_a = this.session) === null || _a === void 0 ? void 0 : _a.sessionId);
                const session = health === null || health === void 0 ? void 0 : health.session;
                // Use loose equality to compare strings, null and undefined considered equals
                if (options.userId != (session === null || session === void 0 ? void 0 : session.userId)
                    || options.client != (session === null || session === void 0 ? void 0 : session.client)
                    || options.customData != (session === null || session === void 0 ? void 0 : session.customData)
                    || options.clientBrand != (session === null || session === void 0 ? void 0 : session.clientBrand)) {
                    // login in case of old Verify detected, it requires separate /login call.
                    yield this.webSdk.login(options);
                }
            });
        }
        wageringStart(jurisdictionArea) {
            var _a, _b, _c, _d, _e, _f;
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.loginOptions || !((_a = this.loginOptions) === null || _a === void 0 ? void 0 : _a.userId)) {
                    return Promise.reject("Set userId before starting game.");
                }
                // start game only if game is not yet started
                // to avoid redundant force check requests
                const health = yield this.webSdk.health(this.loginOptions, (_b = this.session) === null || _b === void 0 ? void 0 : _b.sessionId);
                this.session = { sessionId: (_c = health === null || health === void 0 ? void 0 : health.session) === null || _c === void 0 ? void 0 : _c.sessionId };
                try {
                    this.session = yield this.webSdk.wageringStart(this.loginOptions, WebSdkClientImpl.headersInterceptor, jurisdictionArea);
                    if (!((_d = this.session) === null || _d === void 0 ? void 0 : _d.sessionId)) {
                        // Old Verify has no session, need to login to override userId stored in Verify
                        yield this.loginIfNeeded(this.loginOptions);
                        this.session = yield this.webSdk.wageringStart(this.loginOptions, WebSdkClientImpl.headersInterceptor, jurisdictionArea);
                    }
                    // checkStatus() returns 401 if not logged in (old sdk behaviour)
                    yield this.webSdk.checkStatus((_e = this.session) === null || _e === void 0 ? void 0 : _e.sessionId);
                }
                catch (e) {
                    // login old Verify used, it requires separate /login request
                    yield this.loginIfNeeded(this.loginOptions);
                    this.session = yield this.webSdk.wageringStart(this.loginOptions, WebSdkClientImpl.headersInterceptor, jurisdictionArea);
                }
                this.webSdkDaemon.startPolling(1000, (_f = this.session) === null || _f === void 0 ? void 0 : _f.sessionId);
            });
        }
        wageringEnd() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                this.webSdkDaemon.stopPolling();
                yield this.webSdk.wageringEnd((_a = this.session) === null || _a === void 0 ? void 0 : _a.sessionId);
            });
        }
        logout() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                this.webSdkDaemon.stopPolling();
                yield this.webSdk.wageringEnd((_a = this.session) === null || _a === void 0 ? void 0 : _a.sessionId);
            });
        }
        checkStatus() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                return this.webSdk.checkStatus((_a = this.session) === null || _a === void 0 ? void 0 : _a.sessionId, WebSdkClientImpl.headersInterceptor);
            });
        }
        getJurisdictionArea(clientKey, clientBrand) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.webSdk.getJurisdictionArea(clientKey, clientBrand);
            });
        }
        getJurisdictionAreaDictionary(clientKey, clientBrand) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.webSdk.getJurisdictionAreaDictionary(clientKey, clientBrand);
            });
        }
        getGameTypes(jurisdictionArea, clientKey, clientBrand) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.webSdk.getGameTypes(jurisdictionArea, clientKey, clientBrand);
            });
        }
        isVerifyActive() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield this.webSdk.health();
                }
                catch (e) {
                    return false;
                }
                return true;
            });
        }
    }

    class GameType {
    }
    GameType.DFS = "DFS";
    GameType.CASINO = "CASINO";
    GameType.BETTING = "BETTING";

    exports.CheckRequestStatus = CheckRequestStatus;
    exports.GameType = GameType;
    exports.WebSdk = WebSdkClientImpl;
    exports.WebSdkLite = WebSdkLiteClientImpl;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
